import React from "react";
import { IconSize, TextColor } from "@twilio-paste/style-props";
import { ProductMessagingIcon } from "@twilio-paste/icons/esm/ProductMessagingIcon";

export const LOGO_TITLE = "GHZ Whatsapp";
export const LOGO_SUB_TITLE = "GHZ Pesquisas";
export const APP_TITLE = "GHZ";

interface LogoTwilioIconProps {
  decorative?: boolean;
  color?: TextColor | undefined;
  size?: IconSize | undefined;
  title?: string;
}

export const AppLogo: React.FC<LogoTwilioIconProps> = ({
  decorative = false,
  color = "colorTextBrandHighlight",
  size = "sizeIcon40",
  title = "app logo",
}) => (
  <ProductMessagingIcon
    decorative={decorative}
    color={color}
    size={size}
    title={title}
  />
);
